<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import LayoutPrive from '@/layouts/LayoutPrive.vue'

const route = useRoute()

// Les deux écrans de connexion n'ont ni barre ni navigation : il n'y a rien
// à naviguer tant qu'aucune session n'est ouverte.
const prive = computed(() => !route.meta.public)
</script>

<template>
  <LayoutPrive v-if="prive">
    <RouterView />
  </LayoutPrive>
  <RouterView v-else />
</template>
